import "./Auth.css";

import { useNavigate } from "react-router-dom";
import logo from "../abe_logo.png";
import { PAGES } from "../constants";

function Auth() {
  const navigate = useNavigate();

  const handleLogin = () => {
    navigate(PAGES.AUTH_LOGIN);
  }

  const handleSignup = () => {
    navigate(PAGES.AUTH_SIGNUP);
  }

  return (
    <div className="Auth">
      <img src={logo} className="Auth-logo" alt="logo" />
      <p>
        Welcome to ABE's corporate credit risk analytics platform<br />
        Login to continue
      </p>

      <div className="Auth-buttons">
        <button className="auth-button" onClick={handleLogin}>Login</button>
        <button className="auth-button" onClick={handleSignup}>Sign up</button>
      </div>
    </div>
  );
}

export default Auth;
